<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    aria-hidden="true"
  >
    <use :href="`#${name}`" />
  </svg>
</template>

<script>
export default {
  name: 'BaseIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 14 },
  },
};
</script>
